import FeedbackTrigger from 'records/FeedbackTrigger';
import CallTrigger from 'records/CallTrigger';
import {Record} from 'immutable';

/**
 * Stores AntiRule option or actual anti Rules.
 * Related to TriggerRuleInfo but has different needs
 */
export default class AntiRule extends Record({
  id: null,
  ruleId: null,
  name: null,
  antiRuleShortName: null,
  ruleShortName: null,
  trendId: null,
  type: null,
  context: null,
  active: true,
}) {
  static getTriggerContext(context) {
    if (context && context.type === 'feedback_trigger') {
      return new FeedbackTrigger(context);
    }
    if (context && context.type === 'call_trigger') {
      return new CallTrigger(context);
    }
  }

  constructor(props = {}) {
    super({
      ...props,
      context: AntiRule.getTriggerContext(props.context),
    });
  }

  getUserIds() {
    return this.context.getUserIds();
  }
}
